export const categories = [
  { id: "all", name: "全部看点" },
  { id: "live", name: "出圈现场" },
  { id: "scene", name: "高能名场面" },
  { id: "twist", name: "神反转" },
  { id: "creative", name: "脑洞挑战" },
  { id: "heal", name: "治愈日常" },
  { id: "food", name: "吃瓜速递" },
];

export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  duration: string;
  views: string;
  hot: number;
  tag: string;
  desc: string;
}

export const videos: VideoItem[] = [
  {
    id: "v01",
    title: "外卖小哥进店被空调冻得瞬间清醒，老板一句话全场笑翻",
    category: "scene",
    categoryName: "高能名场面",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20delivery%20rider%20laughing%20at%20a%20bright%20cozy%20street%20food%20shop%20counter%2C%20warm%20neon%20signs%2C%20candid%20funny%20moment%2C%20cinematic%20short%20video%20frame%2C%20vibrant%20colors&width=900&height=560&seq=vg-live-01&orientation=landscape",
    duration: "00:42",
    views: "862万",
    hot: 96,
    tag: "今日爆火",
    desc: "一段不到一分钟的日常互动，因一句临时接梗迅速出圈，评论区都在刷同一句话。",
  },
  {
    id: "v02",
    title: "高考结束那天他冲出考场，对着镜头说了一句话让人破防",
    category: "heal",
    categoryName: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=a%20teenager%20in%20school%20uniform%20walking%20out%20of%20exam%20hall%20toward%20golden%20sunlight%2C%20emotional%20heartwarming%20moment%2C%20soft%20film%20grain%2C%20cinematic%20short%20film%20frame&width=900&height=560&seq=vg-heal-02&orientation=landscape",
    duration: "00:58",
    views: "1204万",
    hot: 99,
    tag: "泪目",
    desc: "校园与青春的最后一面，被一支手机镜头完整记录，朴素的一句话击中无数人的青春记忆。",
  },
  {
    id: "v03",
    title: "大妈用三个空瓶徒手开椰子，手法之流畅让网友直呼专业",
    category: "creative",
    categoryName: "脑洞挑战",
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20opening%20a%20coconut%20with%20plastic%20bottles%20in%20a%20sunny%20market%2C%20surprised%20onlookers%2C%20fun%20life%20hack%2C%20bright%20daylight%2C%20short%20video%20frame&width=900&height=560&seq=vg-creative-03&orientation=landscape",
    duration: "00:35",
    views: "543万",
    hot: 88,
    tag: "神操作",
    desc: "民间高手在线秀手艺，一段三秒钟的操作被网友逐帧慢放，评论区变成教学现场。",
  },
  {
    id: "v04",
    title: "流浪猫蹭进教室赖着不走，全班同学默契配合藏猫整节课",
    category: "heal",
    categoryName: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=a%20stray%20cat%20sitting%20on%20a%20classroom%20desk%20while%20students%20giggle%2C%20warm%20classroom%20lighting%2C%20cozy%20wholesome%20scene%2C%20cinematic%20short%20video%20frame&width=900&height=560&seq=vg-cat-04&orientation=landscape",
    duration: "01:06",
    views: "731万",
    hot: 91,
    tag: "治愈",
    desc: "课堂上的小插曲被后排同学全程记录，教科书级的团结合作，弹幕刷屏求后续。",
  },
  {
    id: "v05",
    title: "小伙网购迷你冰箱，到货发现还没巴掌大，拆箱全程高能",
    category: "twist",
    categoryName: "神反转",
    cover: "https://readdy.ai/api/search-image?query=surprised%20young%20man%20unboxing%20a%20tiny%20miniature%20fridge%20at%20home%2C%20funny%20reaction%2C%20cluttered%20lively%20room%2C%20unboxing%20video%20frame%2C%20playful%20mood&width=900&height=560&seq=vg-twist-05&orientation=landscape",
    duration: "01:24",
    views: "476万",
    hot: 84,
    tag: "神反转",
    desc: "买家秀与卖家秀的极限拉扯，结尾一个反转让整段视频的评论走向彻底翻盘。",
  },
  {
    id: "v06",
    title: "街头随机采访年轻人：最想对五年前的自己说的一句话",
    category: "live",
    categoryName: "出圈现场",
    cover: "https://readdy.ai/api/search-image?query=street%20interviewer%20with%20microphone%20talking%20to%20young%20pedestrians%20in%20a%20vibrant%20city%20street%2C%20evening%20neon%20bokeh%2C%20documentary%20short%20video%20frame&width=900&height=560&seq=vg-interview-06&orientation=landscape",
    duration: "01:47",
    views: "954万",
    hot: 93,
    tag: "街头",
    desc: "随机街采遇到人间清醒的回答，几句大实话让无数年轻人默默点了收藏。",
  },
  {
    id: "v07",
    title: "爷爷第一次用视频电话，对着屏幕那边的孙子念叨了二十分钟",
    category: "heal",
    categoryName: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=elderly%20grandfather%20talking%20to%20grandson%20on%20a%20video%20call%2C%20warm%20home%20living%20room%2C%20touching%20family%20moment%2C%20soft%20golden%20light%2C%20emotional%20short%20film%20frame&width=900&height=560&seq=vg-grandpa-07&orientation=landscape",
    duration: "01:38",
    views: "689万",
    hot: 89,
    tag: "泪目",
    desc: "跨越两代人的一通电话，简单家常话里藏着最重的牵挂，网友：哭着看完。",
  },
  {
    id: "v08",
    title: "深夜食堂老板的隐藏菜单曝光：一碗面里藏了三种惊喜",
    category: "food",
    categoryName: "吃瓜速递",
    cover: "https://readdy.ai/api/search-image?query=chef%20serving%20a%20steaming%20bowl%20of%20noodles%20at%20a%20cozy%20late%20night%20street%20eatery%2C%20steam%20rising%2C%20warm%20lantern%20light%2C%20appetizing%20food%20short%20video%20frame&width=900&height=560&seq=vg-noodle-08&orientation=landscape",
    duration: "02:05",
    views: "318万",
    hot: 78,
    tag: "美食",
    desc: "一份菜单上没有的隐藏面，被探店博主无意拍下，评论区连夜有人去蹲开门。",
  },
  {
    id: "v09",
    title: "下雨天公交车司机的一个减速动作，感动了整条街",
    category: "scene",
    categoryName: "高能名场面",
    cover: "https://readdy.ai/api/search-image?query=bus%20driver%20slowing%20down%20to%20let%20pedestrians%20cross%20on%20a%20rainy%20city%20street%2C%20umbrellas%2C%20reflective%20pavement%2C%20cinematic%20touching%20moment%2C%20short%20video%20frame&width=900&height=560&seq=vg-bus-09&orientation=landscape",
    duration: "00:51",
    views: "587万",
    hot: 87,
    tag: "感动",
    desc: "平凡岗位上的善意瞬间被记录，一个小小的动作传递出城市温度。",
  },
  {
    id: "v10",
    title: "两岁萌娃第一次自己穿鞋，成功后的表情让全家笑到扶墙",
    category: "heal",
    categoryName: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=a%20toddler%20proudly%20showing%20self%20put%20shoes%2C%20happy%20laughing%20family%2C%20bright%20sunny%20living%20room%2C%20cute%20heartwarming%20moment%2C%20short%20video%20frame&width=900&height=560&seq=vg-baby-10&orientation=landscape",
    duration: "00:39",
    views: "422万",
    hot: 82,
    tag: "萌娃",
    desc: "成长路上的小小里程碑，孩子的骄傲脸配上全家人的笑，治愈一整天。",
  },
  {
    id: "v11",
    title: "网友用一万张照片做定格动画，重现一座小城的日出到日落",
    category: "creative",
    categoryName: "脑洞挑战",
    cover: "https://readdy.ai/api/search-image?query=timelapse%20stop%20motion%20of%20a%20small%20city%20skyline%20from%20sunrise%20to%20sunset%2C%20artistic%20colorful%20sky%2C%20creative%20animation%20process%2C%20cinematic%20wide%20shot&width=900&height=560&seq=vg-timelapse-11&orientation=landscape",
    duration: "01:12",
    views: "1108万",
    hot: 98,
    tag: "创作",
    desc: "用一万张照片拼出的城市日记，画面每一帧都是创作者熬过的夜。",
  },
  {
    id: "v12",
    title: "村民误把网红充电宝当成宝盒，端回家围观到半夜",
    category: "twist",
    categoryName: "神反转",
    cover: "https://readdy.ai/api/search-image?query=villagers%20gathering%20curiously%20around%20a%20small%20gadget%20on%20a%20wooden%20table%20at%20night%2C%20warm%20lantern%20light%2C%20funny%20rural%20scene%2C%20short%20video%20frame&width=900&height=560&seq=vg-village-12&orientation=landscape",
    duration: "00:47",
    views: "366万",
    hot: 76,
    tag: "好笑",
    desc: "一场误会引发全村围观，结尾的反转让整个故事变得又好笑又暖心。",
  },
];